/**
 * Shared visual tokens for the public landing page (professional SaaS look).
 * Scoped to landing components — does not change the global MUI theme.
 */
export const LANDING_FONTS = {
  sans: '"DM Sans", "Segoe UI", system-ui, sans-serif',
};

export const LANDING_COLORS = {
  ink: '#0B1220',
  inkSoft: '#152238',
  mist: '#F4F7FB',
  mistDeep: '#E8F0FE',
  line: 'rgba(15, 23, 42, 0.08)',
  accent: '#1D4ED8',
  accentHover: '#1E40AF',
  onDarkMuted: 'rgba(255,255,255,0.72)',
  onLightMuted: '#475569',
};

/** Light hero / closing-band background — readable, not near-black. */
export const LANDING_LIGHT_BAND_BG = `
  radial-gradient(1200px 520px at 12% -8%, rgba(37, 99, 235, 0.14), transparent 58%),
  radial-gradient(900px 420px at 92% 8%, rgba(14, 165, 233, 0.10), transparent 52%),
  linear-gradient(180deg, #EEF4FF 0%, ${LANDING_COLORS.mist} 42%, #FFFFFF 100%)
`;

export const landingSectionTitleSx = {
  fontFamily: LANDING_FONTS.sans,
  fontWeight: 700,
  letterSpacing: '-0.03em',
  fontSize: { xs: '1.75rem', md: '2.35rem' },
  lineHeight: 1.15,
};

export const landingSectionSubtitleSx = {
  fontFamily: LANDING_FONTS.sans,
  fontWeight: 400,
  fontSize: { xs: '1rem', md: '1.125rem' },
  lineHeight: 1.65,
  color: 'text.secondary',
  maxWidth: 640,
  mx: 'auto',
};
